"use client";
import { Text } from "@/components/atoms/Text/Text";
import { Plug01Icon } from "@hugeicons/core-free-icons";
import { Icon } from "@/components/atoms/Icon/Icon";

interface Props {
  providerName: string;
  detail?: string;
}

export function UnsupportedNotice({ providerName, detail }: Props) {
  return (
    <div className="flex flex-col items-center gap-3 rounded-2xl border border-dashed border-border-base px-6 py-10 text-center" data-sentry-component="UnsupportedNotice" data-sentry-source-file="UnsupportedNotice.tsx">
      <Icon icon={Plug01Icon} size={28} tone="muted" data-sentry-element="Icon" data-sentry-source-file="UnsupportedNotice.tsx" />
      <Text variant="body" data-sentry-element="Text" data-sentry-source-file="UnsupportedNotice.tsx">No connection method available</Text>
      <Text variant="small" tone="muted" className="max-w-[360px]" data-sentry-element="Text" data-sentry-source-file="UnsupportedNotice.tsx">
        {detail ??
          `${providerName} doesn't currently expose a connection flow you can manage from settings. Add a block that uses ${providerName} to enable this.`}
      </Text>
    </div>
  );
}
